import { Dictionary, EntityState } from '@reduxjs/toolkit';

export const ensureEntityIdsAreSet = (project: any): any => {
    return {
        ...project,
        variables: ensureEntityIdsAreSetFor(project.variables),
        inputs: ensureEntityIdsAreSetFor(project.inputs),
        variants: ensureEntityIdsAreSetFor(project.variants)
    };
};

const ensureEntityIdsAreSetFor = (state: EntityState<any>): EntityState<any> => {

    const entities = {} as Dictionary<any>;

    for (const [id, entity] of Object.entries(state.entities)) {
        entities[id] = {
            ...entity,
            id: id
        };
    }

    return {
        ids: state.ids,
        entities: entities
    };
};